import { render, staticRenderFns } from "./CsvImportStudents.vue?vue&type=template&id=0d48915a"
import script from "./CsvImportStudents.vue?vue&type=script&lang=ts"
export * from "./CsvImportStudents.vue?vue&type=script&lang=ts"
import style0 from "./CsvImportStudents.vue?vue&type=style&index=0&id=0d48915a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports